<h3>Features</h3>

<mat-selection-list dense #matFeatureList >
	  <mat-list-option *ngFor="let feature of features" [value]="feature">
	    {{feature.featureName}} {{feature.featureId}}
	  </mat-list-option>
</mat-selection-list>

	<p>{{selectedFeature}}</p>